import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetWorkspaceQuery = (workspaceId?: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["workspaces", workspaceId],
    queryFn: async () => {
      const { data, status } = await authApi.get<Array<Workspace>>(
        `/workspace/${workspaceId}`
      );
      return { data, status };
    },
  });

  return result;
};
